import UnitFormatter from './UnitFormatter';
import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      sortable: true,
      minWidth: 200,
    },
    {
      prop: 'abbreviation',
      label: i18n.t('common_words.symbol'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'data_formate',
      label: i18n.t('labor.unit_format'),
      sortable: true,
      align: 'center',
      formatter: UnitFormatter,
      minWidth: 170,
    },
  ];

  return { tableColumns };
};
export default configTable;
